import { observer } from "mobx-react-lite";
import React from "react";
import { Alert } from "react-bootstrap";
import { translateGeneral } from "utils/localizations";

export interface PossibleSEPAPaymentWarningProps {
  show: boolean;
}

const PossibleSEPAPaymentWarning = observer((props: PossibleSEPAPaymentWarningProps) => {
  if (!props.show) {
    return null;
  }

  return (
    <div className="col-12">
      <Alert variant="warning">{translateGeneral("possibleSEPAPaymentWarning")}</Alert>
    </div>
  );
});

export default PossibleSEPAPaymentWarning;
